import React from "react";

export default () => {
  return (
    <iframe
      style={{ display: "block", width: "100%", height: "100%", border: 0 }}
      src="/iot-ui/?isAside=0#/equip-list"
    ></iframe>
  );
};
